import React, { Component } from 'react';
import chingoDentalLogo from '@/assets/img/chingo-dental-logo.png';

class PrintOrthoRetention extends Component {
    render() {
        return (
            <div className="print-page print-ortho-retention">
                <div className="ortho-retention-header">
                    <div className="ortho-retention-logo-wrap">
                        <img
                            className="ortho-retention-logo"
                            src={chingoDentalLogo}
                            alt="Chingo Dental"
                        />
                    </div>

                    <div className="ortho-retention-title-wrap">
                        <div className="ortho-retention-title">
                            CAM KẾT ĐỒNG Ý CHUYỂN SANG GIAI ĐOẠN DUY TRÌ
                        </div>
                        <div className="ortho-retention-subtitle">
                            (Dành cho bệnh nhân điều trị chỉnh nha bằng KHAY NIỀNG TRONG SUỐT)
                        </div>
                    </div>
                </div>

                <div className="ortho-retention-content">
                    <p>
                        Tôi tên là: .................................................................................................CMND số........................................
                    </p>

                    <p>
                        Là&nbsp;&nbsp;&nbsp;☐ bệnh nhân&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;☐ thân nhân đại diện của bệnh nhân ..............................................................................
                    </p>

                    <p>
                        Hiện đang điều trị chỉnh nha bằng khay trong suốt của hãng ..........................................................tại chi nhánh
                        <br />
                        ................................................................... Nha khoa Chingo Dental.
                    </p>

                    <p className="ortho-retention-italic">
                        Sau quá trình điều trị, tôi và bác sĩ điều trị thống nhất đã đạt được mục tiêu điều trị về khớp răng và thẩm mỹ mô mềm và đồng thuận quyết định tháo nút đặt lực, chuyển sang giai đoạn duy trì. Tôi hoàn toàn đồng ý với các chi tiết sau:
                    </p>

                    <ul className="ortho-retention-bullets ortho-retention-main-bullets">
                        <li>
                            Tôi /thân nhân của tôi đã được bác sĩ giải thích đầy đủ cách thức chăm sóc răng sau chỉnh nha và có trách nhiệm tuân thủ chỉ định đeo hàm duy trì để duy trì kết quả chỉnh nha đang có.
                        </li>
                        <li>
                            Tôi /thân nhân của tôi hiểu rằng để kết thúc điều trị, bác sĩ sẽ tiến hành tháo nút đặt lực và các khí cụ niềng răng khác (nếu có). Nếu trước khi thời gian sử dụng gói dịch vụ theo quy định của hãng kết thúc mà tôi /thân nhân của tôi muốn đặt ra mục tiêu điều trị khác và tiếp tục chỉnh răng theo gói thì tôi có thể liên hệ phòng khám để tiến hành.
                        </li>
                        <li>
                            Tôi /thân nhân của tôi có trách nhiệm quay lại nhận hàm duy trì theo đúng hẹn do bác sĩ chỉ định. Nếu không tuân thủ mà hàm duy trì không vừa (đối với hàm duy trì nội địa) HOẶC hết thời gian bảo hành của hãng (đối với hàm duy trì chính hãng) thì tôi sẽ chịu hoàn toàn trách nhiệm.
                        </li>
                        <li>
                            Hàm duy trì nội địa được phòng khám bảo hành trong vòng 01 tháng kể từ ngày nhận hàm trong các trường hợp gãy, vỡ. Hàm duy trì chính hãng được hãng bảo hành với sự hỗ trợ của phòng khám theo chính sách chung của hãng sản xuất. Để được bảo hành, tôi /thân nhân của tôi cần mang hàm duy trì này tới phòng khám.
                        </li>
                    </ul>

                    <p className="ortho-retention-italic ortho-retention-confirm-title">
                        Tôi ký bản cam kết ngày nghĩa là:
                    </p>

                    <ul className="ortho-retention-bullets ortho-retention-confirm-bullets">
                        <li>Tôi đã đọc và hiểu nội dung của bản cam kết.</li>
                        <li>Tất cả thắc mắc của tôi đã được cung cấp thông tin trả lời thỏa đáng.</li>
                        <li>Tôi cam kết sẽ không thắc mắc hay khiếu nại gì về sau.</li>
                    </ul>

                    <div className="ortho-retention-signature-line">
                        <strong>
                            Bệnh nhân/thân nhân (kí và ghi rõ họ tên): ...........................................................
                        </strong>
                        <strong>Ngày: ..../..../.......</strong>
                    </div>

                    <div className="ortho-retention-separator" />

                    <div className="ortho-retention-staff-title">
                        Phần dành cho nhân viên phòng khám:
                    </div>

                    <div className="ortho-retention-patient-line">
                        Tên bệnh nhân: ............................................................................................SĐT.................................................
                    </div>

                    <table className="ortho-retention-table">
                        <tbody>
                            <tr>
                                <td className="ortho-retention-documents-cell">
                                    <div className="ortho-retention-table-heading">
                                        Đính kèm các tài liệu:
                                    </div>
                                    <div>1) .............................................................</div>
                                    <div>2) .............................................................</div>
                                    <div>3) .............................................................</div>
                                </td>
                                <td className="ortho-retention-recipients-cell">
                                    <div className="ortho-retention-table-heading">Nơi nhận:</div>
                                    <div>☐ Lưu HSBA&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;☐ Labo</div>
                                    <div>☐ Bộ phận y tá&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;☐ Bộ phận sales</div>
                                    <div>☐ Trả bệnh nhân&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;☐ Văn phòng (Bộ phận):.....................</div>
                                    <div>☐ Khác: ................................................................................</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <style>
                    {`
                        @page {
                            size: A4 portrait;
                            margin: 0;
                        }

                        .print-ortho-retention,
                        .print-ortho-retention * {
                            box-sizing: border-box;
                        }

                        .print-ortho-retention {
                            width: 210mm;
                            height: 297mm;
                            overflow: hidden;
                            padding: 11.4mm 11.4mm 10mm;
                            background: #fff;
                            color: #000;
                            font-family: "Times New Roman", Times, serif;
                            font-size: 12pt;
                            font-weight: 400;
                            line-height: 1.15;
                        }

                        .ortho-retention-header {
                            display: grid;
                            grid-template-columns: 50.8mm 1fr;
                            align-items: start;
                            width: 100%;
                            margin-bottom: 11.4mm;
                        }

                        .ortho-retention-logo-wrap {
                            padding-left: 1.8mm;
                            padding-top: 0.1mm;
                        }

                        .ortho-retention-logo {
                            display: block;
                            width: 45.77mm;
                            height: 8.47mm;
                            object-fit: contain;
                        }

                        .ortho-retention-title-wrap {
                            text-align: center;
                            white-space: nowrap;
                        }

                        .ortho-retention-title {
                            font-size: 14pt;
                            line-height: 1.05;
                            font-weight: 700;
                        }

                        .ortho-retention-subtitle {
                            margin-top: 0.6mm;
                            font-size: 12pt;
                            line-height: 1.05;
                            font-style: italic;
                        }

                        .ortho-retention-content p {
                            margin: 0 0 4.3mm;
                        }

                        .ortho-retention-italic {
                            padding-right: 2mm;
                            font-style: italic;
                        }

                        .ortho-retention-bullets {
                            list-style: none;
                            width: 100%;
                            margin: 0;
                            padding: 0;
                        }

                        .ortho-retention-bullets li {
                            position: relative;
                            margin: 0;
                            padding: 0 0 0 5.5mm;
                            text-indent: 0;
                            text-align: left;
                        }

                        .ortho-retention-bullets li::before {
                            content: "•";
                            position: absolute;
                            left: 0;
                            top: 0;
                            text-indent: 0;
                            font-family: "Times New Roman", Times, serif;
                            font-size: 12pt;
                        }

                        .ortho-retention-main-bullets {
                            margin-top: 6.9mm;
                            margin-bottom: 2.1mm;
                        }

                        .ortho-retention-main-bullets li {
                            margin-bottom: 0.2mm;
                            line-height: 1.30;
                        }

                        .ortho-retention-confirm-title {
                            margin-bottom: 4.2mm !important;
                        }

                        .ortho-retention-confirm-bullets {
                            margin-bottom: 4.5mm;
                        }

                        .ortho-retention-confirm-bullets li {
                            min-height: 5.4mm;
                        }

                        .ortho-retention-signature-line {
                            display: flex;
                            align-items: baseline;
                            justify-content: space-between;
                            width: calc(100% - 7.5mm);
                            margin-bottom: 8.6mm;
                            white-space: nowrap;
                        }

                        .ortho-retention-separator {
                            height: 0;
                            margin: 0 7.5mm 5.2mm 0;
                            border-top: 0.25mm solid #000;
                        }

                        .ortho-retention-staff-title {
                            margin-bottom: 5.2mm;
                            font-weight: 700;
                            font-style: italic;
                            text-decoration: underline;
                        }

                        .ortho-retention-patient-line {
                            margin-bottom: 4.5mm;
                            line-height: 1.15;
                        }

                        .ortho-retention-table {
                            width: calc(100% - 9.4mm);
                            margin-left: 3.2mm;
                            border-collapse: collapse;
                            table-layout: fixed;
                            font-family: "Times New Roman", Times, serif;
                            font-size: 12pt;
                            line-height: 1.04;
                        }

                        .ortho-retention-table td {
                            vertical-align: top;
                            border: 0.25mm solid #000;
                            padding: 0.8mm 1.7mm 0.7mm;
                        }

                        .ortho-retention-documents-cell {
                            width: 41%;
                        }

                        .ortho-retention-documents-cell > div {
                            white-space: nowrap;
                        }

                        .ortho-retention-recipients-cell {
                            width: 59%;
                            white-space: nowrap;
                        }

                        .ortho-retention-table-heading {
                            font-weight: 700;
                            font-style: italic;
                        }

                        @media print {
                            html,
                            body {
                                width: 210mm !important;
                                height: 297mm !important;
                                margin: 0 !important;
                                padding: 0 !important;
                                background: #fff !important;
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                            }

                            .print-ortho-retention {
                                width: 210mm !important;
                                height: 297mm !important;
                                margin: 0 !important;
                                break-after: avoid-page;
                                page-break-after: avoid;
                            }
                        }
                    `}
                </style>
            </div>
        );
    }
}

export default PrintOrthoRetention;
